/* eslint-disable max-len */
import React from 'react';
function TodayOutlined() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zm0-12H5V5h14v2z" }),
        React.createElement("path", { d: "M7 11h5v5H7z" })));
}
export default TodayOutlined;
